import { render } from "./AssetEditor.vue?vue&type=template&id=40da66fc"
import script from "./AssetEditor.vue?vue&type=script&lang=js"
export * from "./AssetEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__